import styled from "styled-components";
import BaseHorizontalRuler from "../../HorizontalRuler";
export const HorizontalRuler = styled(BaseHorizontalRuler) `
  & {
    display: none;
  }

  *:not(:empty) + &:not(:last-child) {
    display: block;
  }
`;
export default HorizontalRuler;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSG9yaXpvbnRhbFJ1bGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VjdGlvbi9zdHlsZWQvSG9yaXpvbnRhbFJ1bGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sbUJBQW1CLE1BQU0sdUJBQXVCLENBQUM7QUFFeEQsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxDQUFBOzs7Ozs7OztDQVF6RCxDQUFDO0FBRUYsZUFBZSxlQUFlLENBQUMifQ==